import dayjs from 'dayjs';
import React from 'react';

export type DescriptionMetaDateProps = {
  epochMillis: number;
  format?: string;
};

const DEFAULT_DATE_FORMAT = 'MMM D, YYYY';

const DescriptionMetaDate: React.FC<DescriptionMetaDateProps> = ({
  epochMillis,
  format = DEFAULT_DATE_FORMAT,
}) => <>{dayjs(epochMillis).format(format)}</>;

export default DescriptionMetaDate;
